import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { TextField, Typography } from 'seagull';
import { RichTextEditor } from 'seagull/components/RichTextEditor/RichTextEditor';
import { getTestIds } from 'seagull/utils/TestIds';
import { validateLegalTermsContent, validateLegalTermsName } from '~/business-logic/validators';
import { useLocaleKeys } from '~/i18n';
import s from './EditExtractedLegalTermsPanel.module.scss';
export const GetEditExtractedLegalTermsPanelTID = (parentTestId)=>getTestIds(parentTestId);
export const EditExtractedLegalTermsPanel = (param)=>{
    let { model, onModelChange, testId } = param;
    const { EditExtractedLegalTermsPanelTestIds } = useMemo(()=>GetEditExtractedLegalTermsPanelTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys('agreementImport.triageModal');
    if (!model.isLegalTermsUnmatched()) return null;
    const legalTerms = model.legalTerms();
    const name = legalTerms.matchStatus === 'unmatched' ? legalTerms.name : '';
    const contentDelta = model.legalTermsContentDelta();
    const nameResult = validateLegalTermsName(name);
    const contentResult = validateLegalTermsContent(contentDelta);
    const nameErrorMessages = {
        empty: t.termsOfServiceNameRequiredError(),
        tooLong: t.termsOfServiceNameTooLongError()
    };
    const nameHelperText = nameResult.valid ? undefined : nameErrorMessages[nameResult.error];
    const contentHelperText = contentResult.valid ? undefined : t.termsOfServiceContentTooLongError();
    return /*#__PURE__*/ _jsxs("div", {
        className: s.root,
        "data-testid": EditExtractedLegalTermsPanelTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsx(TextField, {
                testId: EditExtractedLegalTermsPanelTestIds.NameInput(),
                label: t.termsOfServiceDocumentNameLabel(),
                value: name,
                onChange: (e)=>onModelChange(model.setLegalTermsName(e.target.value)),
                error: !nameResult.valid,
                helperText: nameHelperText,
                width: "100%"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: s.editorSection,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        skin: "secondary",
                        children: t.termsOfServiceDocumentContentLabel()
                    }),
                    /*#__PURE__*/ _jsx(RichTextEditor, {
                        testId: EditExtractedLegalTermsPanelTestIds.ContentEditor(),
                        editorHeight: 300,
                        initialValue: contentDelta !== null && contentDelta !== void 0 ? contentDelta : undefined,
                        error: !contentResult.valid,
                        helperText: contentHelperText,
                        onChange: (delta)=>onModelChange(model.setLegalTermsContent(delta))
                    })
                ]
            })
        ]
    });
};
